import { useState } from 'react'
import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { getCatalogoCondicao } from '../../../formularios/core/condicao/catalogo'
import { compararVersoes, listarVersoes, obterProtocolo } from '../../core/_requests'
import { useEmpresaDaTela } from '../../core/useEmpresaDaTela'

/**
 * Dados da tela "Comparar versões" (T7a AC3): a versão do `:id`, as demais versões da empresa
 * (opções do "Comparar com") e a comparação. `com` vazio = comparar com a vigente (padrão).
 */
export const useComparacaoProtocolo = () => {
  const { id } = useParams()
  const idProtocolo = Number(id)
  const { idEmpresa } = useEmpresaDaTela()
  const [com, setCom] = useState<number | undefined>(undefined)

  const { data: protocolo } = useQuery(
    ['protocolos-triagem', 'detalhe', idProtocolo],
    () => obterProtocolo(idProtocolo),
    { enabled: !!idProtocolo, retry: false }
  )
  const { data: versoes } = useQuery(
    ['protocolos-triagem', 'versoes', idEmpresa],
    () => listarVersoes(idEmpresa as number),
    { enabled: !!idEmpresa, retry: false }
  )
  const comparacao = useQuery(
    ['protocolos-triagem', 'comparacao', idProtocolo, com ?? 'vigente'],
    () => compararVersoes(idProtocolo, com),
    { enabled: !!idProtocolo, retry: false }
  )
  const { data: catalogo } = useQuery(['condicao', 'catalogo'], () => getCatalogoCondicao(), {
    retry: false,
    staleTime: 60 * 60 * 1000,
  })

  const outrasVersoes = (versoes ?? []).filter((versao) => versao.id !== idProtocolo)

  return { idProtocolo, idEmpresa, protocolo, outrasVersoes, comparacao, catalogo, com, setCom }
}
